import { network } from 'services/network';

export const deleteGateTemplate = (templateId) => {
    return network
        .post('api/bo/phaseperformance/deleteGateTemplate', {
            template_id: templateId,
        })
        .then((response) => response.data);
};
